import { HttpInterceptorFn } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { environments } from '@brand/config/environments';

/** Página actual para los eventos de Meta (`event_source_url`); el `Referer` cross-origin solo trae el dominio. */
export const EVENT_SOURCE_URL_HEADER = 'X-Event-Source-Url';

/** Solo con sesión: esas peticiones ya tienen preflight por `Authorization`, el header no agrega uno nuevo. */
export const eventSourceUrlInterceptor: HttpInterceptorFn = (req, next) => {
  if (
    !isPlatformBrowser(inject(PLATFORM_ID)) ||
    !req.headers.has('Authorization') ||
    !req.url.startsWith(environments.BACKEND)
  ) {
    return next(req);
  }
  return next(
    req.clone({ setHeaders: { [EVENT_SOURCE_URL_HEADER]: location.href } })
  );
};
